module.exports = __webpack_public_path__ + "media/img/favicon/favicon-16x16-731aefbcfbcfa1ef0501276cee5df302.png";